import FormOTPAndPIN from "@components/inputs/FormOTPAndPIN";
import { usePostLoginCheck } from "@components/utils/Auth/hooks";
import { RegisterCallbackProps } from "@components/utils/Auth/types";
import { OnboardMode } from "@constants";
import { useOnboardingPhone } from "@hooks/useOnboardingPhone";

interface RegisterPPProps extends RegisterCallbackProps {}

const RegisterPP = ({
  onLoginSuccess,
  onPostLoginCheckFailed,
  onRegisterSuccess,
  onPostLoginCheckPassed,
  deferUpdateToken,
}: RegisterPPProps) => {
  const { phone } = useOnboardingPhone();
  const postLoginCheck = usePostLoginCheck({
    onLoginSuccess,
    onPostLoginCheckPassed,
    onPostLoginCheckFailed,
    redirectHome: false,
  });

  return (
    <FormOTPAndPIN
      phone={phone}
      mode={OnboardMode.REGISTER}
      onLoginSuccess={postLoginCheck}
      onRegisterSuccess={onRegisterSuccess}
      otpMode="register"
      deferUpdateToken={deferUpdateToken}
    />
  );
};

export default RegisterPP;
